export const getUserLanguage = () => {
  const language = navigator.language;
  return localStorage.getItem('lang') || language.split('-')[0];
};
